import React, { useEffect, useState } from "react";
import { PhoneCall } from "lucide-react";
import { WA_BASE_URL } from "../../../mock";

const StickyMobileCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || window.pageYOffset;
      setVisible(y > 260);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    const url = `${WA_BASE_URL}?text=${encodeURIComponent(
      "Halo, saya lihat bumbu CINEURASA dan mau pesan."
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div
      className={`fixed inset-x-0 bottom-3 z-40 mx-auto flex max-w-md justify-center px-3 transition-all duration-300 ease-out md:hidden ${
        visible
          ? "translate-y-0 opacity-100"
          : "translate-y-5 opacity-0 pointer-events-none"
      }`}
    >
      <button
        onClick={handleClick}
        className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-emerald-700 px-4 py-2.5 text-xs font-semibold text-emerald-50 shadow-lg transition-transform duration-200 ease-out hover:bg-emerald-800 hover:-translate-y-0.5 active:translate-y-0"
      >
        <PhoneCall className="w-4 h-4" />
        <span>Pesan Sekarang via WhatsApp</span>
      </button>
    </div>
  );
};

export default StickyMobileCTA;
